import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

const getAssignmentUuid = createUUID();
export default function useApprovedOrderActions({
  id: orderId,
  modifiedOn,
  onRefresh,
}) {
  const stateManager = useComponentState();
  const [showDrawer, setShowDrawer] = useState(false);
  const [assignments, setAssignments] = useState([]);

  const getAssignments = (id) => {
    stateManager.run(async () => {
      const response = await taskService.assignmentPreviews.get(id);
      setAssignments(response.data);
    }, getAssignmentUuid);
  };

  const releaseAssignments = () => {
    stateManager.run(async () => {
      const response = await taskService.order.place({
        orderId,
        modifiedOn,
        toastMessageConfig: {
          success: { text: "Assignments released successfully" },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        onRefresh();
      }
      setShowDrawer(false);
    }, getAssignmentUuid);
  };

  return {
    showDrawer,
    setShowDrawer,
    isLoading: stateManager.isBusy(),
    assignments,
    setAssignments,
    getAssignments,
    releaseAssignments,
  };
}
